// extracted by mini-css-extract-plugin
module.exports = {"teams":"teams_teams__3Lk9S","container-badge":"teams_container-badge__2fxkq"};